const API_URL = process.env.REACT_APP_BACKEND_URL;
export const IMG_CACHE = 'kj-img-v1';
export const DATA_CACHE = 'kj-offline-v1';
const LS_KEY = 'kj-catalog-offline';
const LS_DISMISS = 'kj-catalog-offline-dismiss';

export const getOfflineInfo = () => {
    try { return JSON.parse(localStorage.getItem(LS_KEY) || 'null'); } catch (e) { return null; }
};
export const dismissOfflinePrompt = () => localStorage.setItem(LS_DISMISS, String(Date.now()));
export const shouldPromptOffline = () => {
    if (!('caches' in window) || getOfflineInfo()) return false;
    const d = Number(localStorage.getItem(LS_DISMISS) || 0);
    return Date.now() - d > 3 * 24 * 3600 * 1000;
};

const collectUrls = async () => {
    const get = async (p) => { try { const r = await fetch(`${API_URL}${p}`); return r.ok ? r.json() : []; } catch (e) { return []; } };
    const [productos, playeras, marcas, config] = await Promise.all([
        get('/api/tienda/productos'), get('/api/tienda/playeras'), get('/api/tienda/marcas'), get('/api/tienda/config')
    ]);
    const data = ['/api/tienda/productos', '/api/tienda/playeras', '/api/tienda/marcas', '/api/tienda/config'];
    const imgs = new Set();
    (productos || []).forEach((p) => {
        data.push(`/api/tienda/productos/${p.id}`, `/api/tienda/productos/${p.id}/relacionados`, `/api/tienda/productos/${p.id}/mas-de-marca`);
        (p.imagenes || []).forEach((u) => u && imgs.add(u));
    });
    (playeras || []).forEach((p) => { if (p.foto) imgs.add(p.foto); (p.foto360 || []).forEach((u) => u && imgs.add(u)); });
    (marcas || []).forEach((m) => { if (m.logo_url) imgs.add(m.logo_url); if (m.banner_url) imgs.add(m.banner_url); });
    if (config?.hero_image) imgs.add(config.hero_image);
    if (config?.logo_url) imgs.add(config.logo_url);
    return { count: (productos || []).length, data: data.map((p) => `${API_URL}${p}`), imgs: [...imgs].map((u) => new URL(u, API_URL || window.location.origin).href) };
};

const appAssets = async () => {
    try {
        const r = await fetch('/asset-manifest.json');
        if (!r.ok) return [];
        const m = await r.json();
        return Object.values(m.files || {}).filter((f) => /\.(js|css)$/.test(f));
    } catch (e) { return []; }
};

const runPool = async (items, worker, onTick, size = 6) => {
    let i = 0;
    const next = async () => {
        while (i < items.length) { const it = items[i++]; await worker(it); onTick(); }
    };
    await Promise.all(Array.from({ length: Math.min(size, items.length) }, next));
};

// Descarga datos + fotos del catalogo en Cache Storage para uso offline
export const downloadCatalog = async (onProgress = () => {}) => {
    if (navigator.storage?.persist) navigator.storage.persist().catch(() => {});
    const [{ count, data, imgs }, assets] = await Promise.all([collectUrls(), appAssets()]);
    const [dataCache, imgCache] = await Promise.all([caches.open(DATA_CACHE), caches.open(IMG_CACHE)]);
    const total = data.length + imgs.length + assets.length;
    let done = 0, failed = 0;
    const tick = () => onProgress({ done: ++done, total });
    const job = async (url, cache, skipIfCached) => {
        try {
            if (skipIfCached && await cache.match(url)) return;
            const res = await fetch(url, { mode: 'cors', cache: 'no-cache' });
            if (res.ok) await cache.put(url, res); else failed++;
        } catch (e) { failed++; }
    };
    onProgress({ done: 0, total });
    await runPool(assets, (u) => fetch(u).catch(() => {}), tick);
    await runPool(data, (u) => job(u, dataCache, false), tick);
    await runPool(imgs, (u) => job(u, imgCache, true), tick);
    const info = { at: Date.now(), productos: count, fotos: imgs.length, failed };
    localStorage.setItem(LS_KEY, JSON.stringify(info));
    return info;
};
